export default __webpack_public_path__ + "static/media/manifestationofwinter.9f928d07.png";